import { render, staticRenderFns } from "./ViewModalEditPedimentos.vue?vue&type=template&id=b196bd1a&"
import script from "./ViewModalEditPedimentos.vue?vue&type=script&lang=js&"
export * from "./ViewModalEditPedimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports